var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InvoicesCreationSection',{attrs:{"invoice":_vm.invoice,"statuses":_vm.statuses},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }